export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/mixed_media.5b44e75.png";